/**
 * Shop Pay's storefront preloader intercepts /checkout anchor clicks and
 * auto-redirects recognized accounts to shop.app. Programmatic navigation
 * with skip_shop_pay=true reaches standard checkout reliably.
 */
(function () {
  const SELECTOR = '[data-hok-standard-checkout]';
  const CHECKOUT_BUTTON_IDS = ['cart-notification-checkout', 'CartDrawer-Checkout'];
  const CHECKOUT_URL = '/checkout?skip_shop_pay=true';

  function navigateToStandardCheckout(event) {
    const trigger = event.target.closest(SELECTOR);
    if (!trigger || trigger.disabled) return;

    const checkoutUrl = trigger.dataset.hokCheckoutUrl || CHECKOUT_URL;
    if (!checkoutUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(checkoutUrl);
  }

  function activateCheckoutButton(button) {
    if (!button) return;

    button.disabled = false;
    button.dataset.hokStandardCheckout = '';
    button.dataset.hokCheckoutUrl = button.dataset.hokCheckoutUrl || CHECKOUT_URL;
  }

  function syncCheckoutButtons(cartData) {
    if (cartData?.item_count > 0) {
      CHECKOUT_BUTTON_IDS.forEach((id) => activateCheckoutButton(document.getElementById(id)));
    }
  }

  document.addEventListener('click', navigateToStandardCheckout, true);

  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => syncCheckoutButtons(cartData));
    }
  });
})();
